import React from 'react';
import {connect} from 'react-redux';
import ContainerItemView from 'go/components/modules/requestDetails/v3/items/shared/ContainerItemView';
import _ from 'lodash';
import WithModal from 'app-ui-componentlibrary/dist/go/components/common/WithModal';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {TRACKER_BUCKETS} from 'go/pages/tracker/constants';
export class ContainerItem extends React.Component {
  state = {
    trackerVariables: {},
    showConfirmationModal: false,
  };

  saveTrackerValue = (trackerName, trackerValue) => {
    const {saveItem, sourcePath, item} = this.props;
    saveItem(sourcePath, {
      ...item,
      additionalInformation: {
        ...item.additionalInformation,
        [trackerName]: trackerValue,
      },
    });
  };

  setUnconfirmedTrackerValue = (trackerName, trackerValue) => {
    this.setState({
      showConfirmationModal: true,
      trackerVariables: {
        [trackerName]: trackerValue,
      },
    });
  };

  closeConfirmationModal = () => {
    this.setState({showConfirmationModal: false});
  };

  renderTrackerVariables = () => {
    const {itemConfig, item} = this.props;

    return _.map(itemConfig.trackerVariables, (trackerVar) => {
      const {NATIONAL_SCOPE} = TRACKER_BUCKETS;
      if (trackerVar.name === NATIONAL_SCOPE) {
        let modalText = _.get(this.state.trackerVariables, NATIONAL_SCOPE)
          ? 'Are you sure you want to identify this project as a national scope project?'
          : 'Are you sure you do not want to identify this project as a national scope project?';

        if (_.get(item, ['additionalInformation', NATIONAL_SCOPE]) === undefined) {
          this.saveTrackerValue(NATIONAL_SCOPE, trackerVar.defaultValue);
        }

        return (
          <WithModal
            key={trackerVar.name}
            title={trackerVar.label}
            handleConfirm={(value) => {
              this.closeConfirmationModal();
              this.saveTrackerValue(
                NATIONAL_SCOPE,
                _.get(this.state.trackerVariables, NATIONAL_SCOPE)
              );
            }}
            open={this.state.showConfirmationModal}
            handleCancel={this.closeConfirmationModal}
            modalText={modalText}
          >
            <Checkbox
              label={trackerVar.label}
              disabled={false}
              checked={!!_.get(item, ['additionalInformation', NATIONAL_SCOPE])}
              handleChange={(label, value) =>
                this.setUnconfirmedTrackerValue(NATIONAL_SCOPE, value)
              }
            />
          </WithModal>
        );
      }
    });
  };

  render() {
    return (
      <ContainerItemView {...this.props}>
        {this.renderTrackerVariables()}
      </ContainerItemView>
    );
  }
}

export const mapStateToProps = (state, props) => {
  const currentlyCollaborating = !!_.get(
    state,
    'dynamicComponent.collaboration.roomList',
    ''
  );
  return {currentlyCollaborating};
};

export default connect(mapStateToProps, null)(ContainerItem);
